







import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import { InjectReactive } from 'vue-property-decorator'
import { TicketCollectionTypeInAdmin } from '@/modules/ticket/models/ticket-collection.model'
import EllipsisLink from '@/modules/shared/components/shared/utils/EllipsLink.vue'
import TicketStatusView from '@/modules/ticket/components/shared/TicketStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import TicketTableActions from '@/modules/ticket/components/shared/table/TicketTableActions.vue'
import { PanelTicketRoute } from '@/modules/ticket/routes/panel-ticket.route'

@Component({
  components: {
    TesTr
  }
})
export default class TicketTableRow extends mixins(TesTableRow) {
  constructor(
    private readonly panelRoute: PanelTicketRoute,
  ) {
    super()
  }

  @InjectReactive()
  tickets!: TicketCollectionTypeInAdmin

  get route() {
    return this.panelRoute
  }


  get fixedData() {
    return {
      routes: this.route,
      statuses: this.tickets.statuses
    }
  }

  protected columnComponents = {
    id: {
      component: EllipsisLink,
      handler: this.ellipsisLinkHandler.bind(this, 'id')
    },
    title: {
      component: EllipsisLink,
      handler: this.ellipsisLinkHandler.bind(this, 'title')
    },
    department: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.department?.title })
    },
    last_answer_date: {
      component: DateTooltipped,
      handler: (value) => ({ isoDate: value })
    },
    status: {
      component: TicketStatusView,
      handler: (value, row, fixedData) => ({ status: value, statuses: fixedData.statuses })
    },
    actions: {
      component: TicketTableActions,
      handler: (value, row, { routes }) => ({ showPageLink: routes.show(row.id) })
    }
  }

  protected ellipsisLinkHandler(name, value, row) {
    return {
      href: this.route.show(row.id),
      text: value.toString()
    }
  }
}
